(ns io.daskul.webapp.widgets.dashboard.item-list
  "Item list widget — compact actionable list for dashboard.

   Expects a metric map with :widget :table shape:
     {:widget        :table
      :key           \"post-trial-follow-ups\"
      :label         \"Post-Trial Follow-ups\"
      :items         [{:primary    \"Maria Lopez\"
                       :secondary  \"Piano Basics · trial 3 days ago\"
                       :badge      \"Needs contact\"
                       :badge-color \"red\"
                       :href       \"/leads/uuid\"}]
      :view-all-href \"/leads?state=trial-attended\"}"
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.ui.icons :as icons]))

(defui item-row
  "Compact item row with hover."
  [{:keys [primary secondary badge badge-color href]}]
  (let [[hovered? set-hovered!] (uix.core/use-state false)
        content
        ($ ui/box
          {:onMouseEnter (when href #(set-hovered! true))
           :onMouseLeave (when href #(set-hovered! false))
           :py 8 :px "sm"
           :style #js {:cursor (when href "pointer")
                       :backgroundColor (when hovered? "var(--mantine-color-gray-0)")
                       :transition "background-color 150ms ease"
                       :borderBottom "1px solid var(--mantine-color-gray-1)"}}
          ($ ui/group {:gap 6 :align "center" :wrap "nowrap"}
            ($ ui/text {:size "sm" :fw 500 :truncate "end"} primary)
            (when badge
              ($ ui/text {:size "xs" :c (str (or badge-color "gray") ".6") :fw 600
                          :style #js {:flexShrink 0 :whiteSpace "nowrap"}}
                (str "\u00B7 " badge))))
          (when secondary
            ($ ui/text {:size "xs" :c "dimmed" :truncate "end" :mt 1}
              secondary)))]
    (if href
      ($ ui/anchor {:href href :underline "never" :c "inherit"} content)
      content)))

(defui item-list
  "Renders actionable items as a compact list with 'View All' footer."
  [{:keys [label subtitle total items view-all-href]}]
  ($ ui/paper {:p 0 :radius "md" :withBorder true}
    ($ ui/group {:justify "space-between" :align "center"
                 :px "sm" :pt "sm" :pb "xs"}
      ($ ui/group {:gap 6 :align "center"}
        ($ ui/text {:size "sm" :fw 700} label)
        (when (and total (pos? total))
          ($ ui/text {:size "sm" :c "dimmed" :fw 500}
            (str "(" total ")"))))
      (when (and view-all-href (seq items))
        ($ ui/anchor {:href view-all-href :underline "never"}
          ($ ui/group {:gap 4 :align "center"}
            ($ ui/text {:size "sm"} "View All")
            ($ icons/icon-chevron-right {:size 14 :stroke 1.5})))))
    (if (empty? items)
      ($ ui/text {:size "sm" :c "dimmed" :px "sm" :pb "sm"} "None")
      ($ ui/box {}
        (when subtitle
          ($ ui/text {:size "xs" :c "dimmed" :tt "uppercase" :fw 600
                      :px "sm" :pt 4 :pb 2}
            subtitle))
        (for [[idx item] (map-indexed vector items)]
          ($ item-row (assoc item :key idx)))))))
